import React from 'react'
import styled from 'styled-components'
import Page, {ErrorMessage} from 'Event/template/Panels/Login/Page'
import {ForgotPasswordProps} from 'auth/password'
import {usePanelsTemplate} from 'Event/template/Panels'
import {useGuestVariables} from 'Event'
import Description from 'Event/auth/ForgotPassword/Description'
import EmailField from 'Event/auth/Login/EmailField'
import SubmitButton from 'Event/auth/ForgotPassword/SubmitButton'

export default function ForgotPassword(props: ForgotPasswordProps) {
  return (
    <Page isPreview={false}>
      <Content {...props} />
    </Page>
  )
}

export function Content(props: ForgotPasswordProps) {
  const template = usePanelsTemplate()
  const {login} = template
  const v = useGuestVariables()

  if (props.resetLinkSent) {
    return (
      <Description aria-label="password reset link sent">
        {v(login.passwordReset.successMessage)}
      </Description>
    )
  }

  return (
    <>
      <Description aria-label="event login description">
        {v(login.passwordReset.description)}
      </Description>
      <StyledForm onSubmit={props.onSubmit}>
        <EmailField {...props} />
        <ErrorMessage>{props.responseError?.message}</ErrorMessage>
        <SubmitButton {...props} />
      </StyledForm>
    </>
  )
}

const StyledForm = styled.form`
  width: 100%;
`
